import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.sms-user-registration', {
        url: '/smsuser_registration',
        component: 'smsUserRegistration',
    })
}



// WEBPACK FOOTER //
// ./src/portal/states/public/sms-user-registration/sms-user-registration.state.js